<template>
    <b-dropdown v-if="selectedOption.label"
                :text="selectedOption.label"
                :toggle-class="['font-size-default', (viewType === 'desktop') ? 'w-100 bg-color-grey--light' : '']"
                :dropup="(viewType === 'mobile') "
                class="d-inline-block dropdown page-sorting-dropdown"
                :disabled="isLocked"
                :class="{ 'w-100': (viewType === 'desktop') }"

    >
        <b-dropdown-item v-for="(option, index) in this.sortingOptions"
                         :key="index"
                         :class="{ active: option.value === selectedOption.value }"
                         :data-option-index="index"
                         @click="optionChanged">
            {{ option.label }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
    export default {
        props: {
            viewType: {
                type: String,
                default: 'desktop',
            },
        },
        data() {
            return {
                eventName: 'page_filter:changed',
                sortingOptions: [],
                defaultSortingOptionIndex: 0,
                selectedOption: {},
                isLocked: MrMovie.filtersLocker.isLocked(),
                init: true
            };
        },
        mounted() {
            // Update the filter disabled state according to the locked state
            VueEvents.$on('filters_locked', state => {
                MrMovie.filtersLocker.setLocked(state);
                this.isLocked = state;
            });

            // Select sorting option by URL parameter 'order_by'
            VueEvents.$on('loaded_filters', filters => {
                if(this.init
                    && typeof MrMovie.pageFilter.getFilters('order_by') !== 'undefined'
                    && typeof MrMovie.pageFilter.getFilters('order_by' !== 'undefined')
                    && typeof MrMovie.pageFilter.getFilters('order_by').getValues()[0] !== 'undefined') {
                    let filterValue = MrMovie.pageFilter.getFilters('order_by').getValues()[0];
                    this.selectedOption = this.sortingOptions[this.getOptionIndexByValue(filterValue)];
                }
            });
        },
        methods: {
            /**
             * Callback for the options click event
             * @return {void}
             */
            optionChanged(event) {

                // if(this.init) {
                //     this.init = false;
                //     return;
                // }

                // Lock the filters on change
                VueEvents.$emit('filters_locked', true);

                const $option = $(event.target);
                this.selectedOption = this.sortingOptions[$option.data('optionIndex')];

                // Emit the global change event
                this.emitSelectedOption();
            },
            /**
             * Set the sorting options to choose from
             * @param options
             * @param setDefault Whether to also set the default option
             * @return {void}
             */
            setSortingOptions(options, setDefault = true) {
                this.sortingOptions = options;

                // Set the default option
                if (setDefault) {
                    if (this.sortingOptions[this.defaultSortingOptionIndex]) {
                        // Set the default option if it exists
                        this.selectedOption = this.sortingOptions[this.defaultSortingOptionIndex];
                    } else if (this.sortingOptions.length) {
                        // Otherwise set the first option as default
                        this.selectedOption = this.sortingOptions[0];
                    }
                }
            },

            /**
             * Get option index by value
             * @param value
             * @returns {*}
             */
            getOptionIndexByValue(value) {
                let optionIndex = 0;

                $.each(this.sortingOptions, function(index, option) {
                    if (option.value === value) {
                        optionIndex = index;
                        return optionIndex;
                    }
                });

                return optionIndex;
            },

            emitSelectedOption() {
                MrMovie.pageFilter.removeFilters('order_by');
                MrMovie.pageFilter.addFilters('order_by', [this.selectedOption.value]);
                MrMovie.pageFilter.updateQueryParams();
                // MrMovie.pageFilter.filter(); // this is temporary skipped because of the page reload
                window.location.reload();
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/base/BasePageSorting.vue